/**
 * Bookly: Redirected header search lands on /collections/all?q=...
 * Shopify collection pages don't filter by q by default, so we do a lightweight
 * client-side filter of the already-rendered product grid.
 *
 * This is intentionally simple and safe: if anything is missing, it exits quietly.
 */
(function() {
  function normalize(str) {
    return (str || '').toString().trim().toLowerCase();
  }

  function run() {
    try {
      var params = new URLSearchParams(window.location.search || '');
      var q = normalize(params.get('q'));
      if (!q) return;

      // Only run on collection pages
      var body = document.body;
      if (!body) return;
      var isCollection = body.classList.contains('template-collection') || body.className.indexOf('template-collection') !== -1;
      if (!isCollection) return;

      var productGrid = document.querySelector('.row.theme-products');
      if (!productGrid) return;

      var items = productGrid.querySelectorAll(':scope > div');
      if (!items || !items.length) return;

      var shown = 0;

      items.forEach(function(item) {
        var titleEl = item.querySelector('.theme-product-title a');
        var vendorEl = item.querySelector('.theme-product-vendor, .product-vendor, .pro-vendor');
        var title = normalize(titleEl ? titleEl.textContent : '');
        var vendor = normalize(vendorEl ? vendorEl.textContent : '');

        // Match on title or vendor/author line if present
        var match = title.indexOf(q) !== -1 || vendor.indexOf(q) !== -1;

        item.style.display = match ? '' : 'none';
        if (match) shown += 1;
      });

      // Add a small info line above the grid (once)
      var existing = document.querySelector('[data-bookly-collection-qinfo]');
      if (!existing) {
        var info = document.createElement('div');
        info.setAttribute('data-bookly-collection-qinfo', 'true');
        info.style.margin = '14px 0 10px';
        info.style.fontSize = '14px';
        info.style.opacity = '0.85';
        info.textContent = 'Søkeresultater for “' + params.get('q') + '” (' + shown + ')';
        var insertPoint = productGrid.parentElement;
        if (insertPoint) insertPoint.insertBefore(info, productGrid);
      }
    } catch (e) {
      // fail silently
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
